import { Box, Stack, Typography } from '@mui/material';
import { useCallback } from 'react';
import { ClassInformation } from './ClassInformation';
import { FullInfoClassModel } from '@shared/types';
import Icon from './images/class-prefix-icon.svg';
import { Chip } from '../../../primitives';
import styled from 'styled-components';
import { PersonAvatarLists } from '../users';
import { Card } from '../../Cards';
import { Icon as IconOpen } from "../../../primitives/icon";
import { ArrowUpRight } from '@phosphor-icons/react';

interface Props {
  data: FullInfoClassModel;
  onClick: (classId: number) => void;
}

const StyledIconOpen = styled(IconOpen)`
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    transition: all 0.2s ease;
  }
`;

export const ClassCard = ({ data, onClick }: Props) => {

  const redirectToClassDetail = useCallback(() => {
    onClick(data.classData.id);
  }, [data.classData.id]);

  return (
    <Card
      title={
        <Stack flexDirection={'row'} justifyContent={'space-between'} marginTop={1} width={'100%'}>
          <Stack flexDirection={'row'} gap={1}>
            <img src={Icon} width={'40px'} height={'40px'} />
            <Box>
              <Chip>
                <Typography color='#4caf50' fontSize='0.75rem'>
                  {data.classData.status === 'Working' ? 'In progress' : data.classData.status}
                </Typography>
              </Chip>
              {data.classData?.classType?.name}: {data.classData?.name || data.classData?.aliasName}
            </Box>
          </Stack>

          <StyledIconOpen>
            <ArrowUpRight size={24} color='#F15E22' onClick={redirectToClassDetail} />
          </StyledIconOpen>
        </Stack>
      }
      $height='100%'
    >
      <PersonAvatarLists title='Teachers & Teaching Assistants' data={data.employees} />
      <ClassInformation data={data.classData} />
    </Card>
  );
};
